import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync, LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { _values } from '@nu-art/ts-common';
import '../permission-keys-editor.scss';
import { Component_AccessLevelsEditor } from './Component_AccessLevelsEditor.js';
import { ModuleFE_PermissionsAssert } from '../../../modules/ModuleFE_PermissionsAssert.js';
export class PermissionKeysEditor extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state ??= this.state ? { ...this.state } : {};
        return state;
    }
    renderKey = (item) => {
        const className = _className('item-list__list-item', item.key === this.state.editedItem?.key ? 'selected' : undefined);
        return _jsx("div", { className: className, onClick: () => this.setState({ editedItem: item }), children: item.key }, item.key);
    };
    renderKeyList = () => {
        const allKeys = ModuleFE_PermissionsAssert.getAllPermissionKeys();
        return _jsxs(LL_V_L, { className: 'item-list', children: [_jsx("div", { className: 'item-list__header', children: "Permission Keys" }), _jsx(LL_V_L, { className: 'item-list__list', children: _values(allKeys).map(this.renderKey) })] });
    };
    renderAccessLevels() {
        if (!this.state.editedItem)
            return null;
        return _jsx(Component_AccessLevelsEditor, { permissionKey: this.state.editedItem });
    }
    renderKeyEditor = () => {
        if (!this.state.editedItem)
            return '';
        return _jsxs(LL_V_L, { className: 'item-editor', children: [_jsx("div", { className: 'item-list__header', children: this.state.editedItem.key }), this.renderAccessLevels()] });
    };
    render() {
        return _jsxs(LL_H_C, { className: 'permissions-key-editor match_parent', children: [this.renderKeyList(), this.renderKeyEditor()] });
    }
}
//# sourceMappingURL=permission-keys-editor.js.map